export class ForgotPasswordRequest{
    userName: string;

    constructor(userName: string){
        this.userName = userName;
    }
}